import React, {Component} from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';

const lookupTheme = {
  container: 'lookup__container',
  // containerOpen: 'react-autosuggest__container--open',
  input: 'input',
  // inputOpen: 'react-autosuggest__input--open',
  // inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'lookup__suggestions-container',
  suggestionsContainerOpen: 'lookup__suggestions-container--open',
  suggestionsList: 'unstyled-list lookup__list',
  suggestion: 'lookup__suggestion-container',
  // suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'lookup__suggestion--highlighted',
  // sectionContainer: 'react-autosuggest__section-container',
  // sectionContainerFirst: 'react-autosuggest__section-container--first',
  // sectionTitle: 'react-autosuggest__section-title'
};


class Lookup extends Component {
  constructor(props) {
    super(props);

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      selectedValue: this.props.selectedSuggestion ? this.props.selectedSuggestion.name : "",
      selectedSuggestion: this.props.selectedSuggestion ? this.props.selectedSuggestion : {},
      suggestions: []
    };
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let suggestions;

    suggestions = this.props.dataList.filter((item) => {
      return Object.keys(item).filter((property) => {
        if (!item[property]) {
          return false;
        }
        return property !== value && item[property].toLowerCase().slice(0, inputLength) === inputValue
      }).length > 0;
    });

    return inputLength === 0 ? [] : (suggestions.length ? suggestions : [{name: 'No Match Found'}]);
  };

  // Use your imagination to render suggestions.
  renderSuggestion = (suggestion) => {
    if (suggestion.name === 'No Match Found') {
      return (
        <div className="lookup__suggestion lookup__suggestion--not-found"
             onClick={(e) => {
               e.stopPropagation()
             }}
        >
          {suggestion.name}
        </div>
      )
    } else {
      return (
        <div className="lookup__suggestion">
          {suggestion.name}
        </div>
      )
    }
  };

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  getSuggestionValue = suggestion => {
    if (suggestion.name !== 'No Match Found') {
      return suggestion.name
    } else {
      return this.state.selectedSuggestion.name;
    }
  };

  onChange = (event, {newValue}) => {
    if (!newValue) {
      this.setState({suggestions: []})
    }
    this.setState({
      selectedValue: newValue
    });
  };

  onSuggestionSelected = (event, {suggestion, method}) => {
    if (method === 'enter') {
      event.preventDefault();
    }
    this.props.onChange(suggestion.value);
    this.setState({
      selectedSuggestion: suggestion
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({value}) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  shouldRenderSuggestions(value) {
    return value.trim().length > 2;
  }

  render() {

    const {selectedValue, suggestions} = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: '',
      value: selectedValue,
      onChange: this.onChange,
      onBlur: this.props.onBlur,
      name: this.props.name
    };

    // Finally, render it!
    return (
      <Autosuggest
        theme={lookupTheme}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        highlightFirstSuggestion
        shouldRenderSuggestions={this.shouldRenderSuggestions}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

export default Lookup;

Lookup.propTypes = {
  dataList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/Lookup/Lookup.js